import { usePlayer, usePlayerStoreApi } from "@utils/player/core/usePlayer";
import { useEffect } from "react";
import { useMe } from "@hooks/trpc/useMe";

import { computeSkipGate, pruneSkipTimestamps } from "./skip";

export function usePlayerSkipGate(): void {
  const playerStore = usePlayerStoreApi();

  const skipTimestamps = usePlayer((s) => s.skipTimestamps);

  const {
    query: { data: user },
  } = useMe();

  useEffect(() => {
    // Prune old timestamps in persisted state.
    const pruned = pruneSkipTimestamps({ timestamps: skipTimestamps });
    if (pruned.length !== skipTimestamps.length) {
      playerStore.setState((state) => {
        state.skipTimestamps = pruned;
      });
    }

    const isPremium = !!(
      user &&
      (user.plan?.type === "premium" ||
        user.consumer?.subscription === "premium")
    );
    const gate = computeSkipGate({ isPremium, timestamps: pruned });

    playerStore.getState().actions.setCanSkip(gate.canSkip, gate.reason as any);
  }, [skipTimestamps, user]);
}
